import React, { useEffect, useState } from 'react';
import api from '../utils/api';
import toast from 'react-hot-toast';

export default function ReferralPage() {
  const [data, setData] = useState(null);
  const [copied, setCopied] = useState(false);

  useEffect(() => {
    api.get('/referrals/me')
      .then(r => setData(r.data))
      .catch(() => toast.error('Sign in to view your referral link'));
  }, []);

  const copyLink = () => {
    navigator.clipboard.writeText(data.share_url);
    setCopied(true);
    toast.success('Link copied!');
    setTimeout(() => setCopied(false), 2000);
  };

  return (
    <div style={{ minHeight: '100vh', background: 'var(--navy)', paddingTop: 56 }}>
      <div style={{ maxWidth: 500, margin: '0 auto', padding: '48px 16px' }}>
        <h2 style={{ fontSize: 24, fontWeight: 700, letterSpacing: '-0.4px', marginBottom: 8 }}>🎁 Invite Friends</h2>
        <p style={{ color: 'var(--text-3)', fontSize: 14, marginBottom: 32 }}>
          You and your friend both earn <strong style={{ color: 'var(--teal)' }}>{data?.points_per_referral || 20} points</strong> when they sign up with your link.
        </p>

        {!data ? (
          <div style={{ background: 'var(--slate)', border: '1px solid var(--border)', borderRadius: 12, padding: 40, textAlign: 'center', color: 'var(--text-3)' }}>
            Sign in to get your referral link
          </div>
        ) : (
          <>
            <div style={{ background: 'var(--slate)', border: '1px solid var(--border)', borderRadius: 16, padding: '24px', marginBottom: 16 }}>
              <div style={{ fontSize: 12, color: 'var(--text-3)', textTransform: 'uppercase', letterSpacing: '0.5px', marginBottom: 10 }}>Your code</div>
              <div style={{
                fontFamily: 'JetBrains Mono, monospace', fontSize: 28, fontWeight: 700,
                color: 'var(--teal)', letterSpacing: '4px', textAlign: 'center',
                padding: '12px 0',
              }}>
                {data.referral_code}
              </div>
            </div>

            <button onClick={copyLink} style={{
              width: '100%', padding: '14px 0', borderRadius: 12, border: 'none',
              background: copied ? 'var(--green)' : 'var(--teal)',
              color: 'var(--navy)', fontWeight: 700, fontSize: 14, cursor: 'pointer',
              transition: 'background 0.2s', marginBottom: 16,
            }}>
              {copied ? '✓ Copied!' : 'Copy invite link'}
            </button>

            <div style={{ background: 'var(--slate)', border: '1px solid var(--border)', borderRadius: 12, padding: '16px', fontSize: 12, color: 'var(--text-3)', wordBreak: 'break-all' }}>
              {data.share_url}
            </div>
          </>
        )}
      </div>
    </div>
  );
}
